<template>
  <div :style="{'text-align': 'center'}">
    <b-row align-h="center">
      <b-col cols="12">
        <h3>Car Photo</h3>
        <b-col cols="12" md="6" offset-md="3" xl="4" offset-xl="4">
          <img :src="vehicleImage" v-if="vehicleImage !== null" :style="{'width': '100%'}" />
        </b-col>
        <p v-if="vehicleImage === null">
          <font-awesome-icon icon="info-circle" class="text-primary" />Please add a photo that shows the front view of your vehicle.
        </p>
      </b-col>
      <b-col class="m-0" cols="10" align="right">
        <fileUploadTemplate v-if="vehicleImage === null || isEditAllow" template="image" :crop="true" :selectCallback="selectCallback" />
      </b-col>
      <b-col class="ml-0" cols="1.5" align="right">
          <b-button size="sm" variant="secondary" @click="closeModal">Close</b-button>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import fileUploadTemplate from "@/components/file-upload-template.vue";
import moment from "moment";

export default {
  name: "vehiclesPhotos",
  components: {
    fileUploadTemplate
  },
  props: {
    selectedVehicle: Object,
    uploadedImageCallback: Function,
    driverId:String,
  },
  computed: {
    vehicleImage() {
      return typeof this.selectedVehicle.pictureUploadId !== "undefined"
        ? this.selectedVehicle.photoUrl
        : null;
    }
  },
  data() {
    return {
      isEditAllow:false
    };
  },
  watch: {},
  async created() {
    if (typeof this.selectedVehicle._id !== "undefined") {
      if(this.selectedVehicle.status !== "active"){
            this.isEditAllow=true;
      }else{
            this.isEditAllow=false;
      }
    }
  },
  methods: {
    async selectCallback(key, file, crop) {
      await shebahApi.api.drivers.vehicles.uploadVehicleImage(this.driverId,
        {
          pictureUploadId: file[0],
          height: crop.height,
          width: crop.width,
          x: crop.x,
          y: crop.y
        },
        this.selectedVehicle._id
      );

    this.uploadedImageCallback();
    },
    closeModal(){
      this.$emit("closeCallback",{});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>